<script lang="ts" setup>
import { PropType } from 'vue'

import IfViewport from '@/components/common/IfViewport.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { RoundStandingsMatch } from '@/store/public/leagues.types'

const leagues = useLeaguesStore()

defineProps({
  rows: {
    type: Array as PropType<RoundStandingsMatch[]>,
    required: true,
  },
  roundId: {
    type: Number,
    required: true,
  },
})
</script>

<template>
  <div class="table-container">
    <table class="table">
      <tbody>
        <tr v-for="(match, i) in rows" :key="`match-${i}`">
          <td class="align-right fit-content">{{ match.number }}.</td>
          <td class="align-right">{{ match.home_team_name }}</td>
          <td class="align-right">
            <span v-if="match.has_scores">{{ match.home_team_points }}</span>
          </td>
          <td class="align-center fit-content">–</td>
          <td>
            <span v-if="match.has_scores">{{ match.away_team_points }}</span>
          </td>
          <td class="align-center">{{ match.away_team_name }}</td>
          <td class="fill noprint noselect">
            <RouterLink
              v-if="match.has_scores"
              :to="{
                path: `/leagues/${leagues.selectedSeason}/${leagues.selectedLeague?.id}/standings/${roundId}/${match.id}`,
              }"
              class="standings-link"
            >
              <small>
                <FontAwesomeIcon class="icon" icon="file-contract" />
                <IfViewport min-width="768">
                  <span>{{ $t('leagues.labels.standings') }}</span>
                </IfViewport>
              </small>
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.icon {
  margin-right: 0.25em;
}
</style>
